import { baseUrl, responseToAsyncSelect, notify } from "./index";
import {
  getToken,
  getUser,
  retreiveCachedResponse,
  cacheResponse
} from "./storage";


export async function getStoreComments(store_id) {
  const token = await getToken();
  let comments = [];
  try {
    let response = await (await fetch(`${baseUrl}/store/inspections`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ store_id })
    })).json();

    comments = response.data !== null ? response.data.inspections.data : null;
    cacheResponse(`getStoreComments:${store_id}`, comments);
  } catch (error) {
    console.error(error);
    comments = await retreiveCachedResponse(`getStoreComments:${store_id}`);
  }

  return comments;
}

export async function getStoreComment(inspection_id) {
  const token = await getToken();
  let comment = {};
  try {
    let response = await (await fetch(
      `${baseUrl}/store/inspections/${inspection_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )).json();

    response.data.require_action = Boolean(response.data.require_action);

    response.data.machines = response.data.machines;
    response.data.tools = response.data.tools;
    response.data.complete = Boolean(response.data.complete);

    comment = response.data;
    cacheResponse(`getStoreComment:${inspection_id}`, comment);
  } catch (error) {
    console.error(error);
    comment = await retreiveCachedResponse(`getStoreComment:${inspection_id}`);
  }

  return comment;
}

export async function getStore(store_id) {
  const token = await getToken();
  let store = {};
  let store_group_id =null;
  try {
    let response = await (await fetch(`${baseUrl}/store`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ store_id })
    })).json();

    store = response.data.stores;
    store_group_id = store !== undefined ? store.store_group_id : null;
    let user_type = response.data.type;
    let add_store_report = document.getElementById('add_store_report');

    if( user_type === 4 ){
      // technician
      if(store_group_id === 3){
        // C 그룹// 보이게
        add_store_report.classList.remove('hide')
      }else{
        // 안보이게
        add_store_report.classList.add('hide')
      }

      // path name 확인하고 리다이렉트
      let path = window.location.pathname;
      if (path === "/comment-form" && store_group_id === 3){
        // window.location.replace("/comment-form/"+store_id)
        window.location.href = "/comment-form/"+store_id
      }
    }
    
    // dispatch(select("store", store));
    cacheResponse(`getStore:${store_id}`, store);
  } catch (error) {
    console.error(error);
    store = await retreiveCachedResponse(`getStore:${store_id}`);
  }

  return store;
}

export async function getStores(name) {
  let stores;
  if (name.length < 3) {
    stores = [];
  } else {
    const token = await getToken();
    try {
      let response = await (await fetch(`${baseUrl}/stores`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ name })
      })).json();
      stores = responseToAsyncSelect(response, "id", "name", "use_app");
      cacheResponse("getStores", stores, true, "value", "use_app");
    } catch (error) {
      console.error(error);
      stores = await retreiveCachedResponse("getStores");
      stores = stores.filter(({ label }) =>
        label.toLowerCase().includes(name.toLowerCase())
      );
    }
  }

  return stores;
}

export async function getNearbyStores({ postCode }) {
  const token = await getToken();
  // Trim the postcode to increase the search radius
  if (postCode.length >= 4) {
    postCode = postCode.slice(0, 3);
  }

  try {
    // If the cached data is fresh enough use that
    const { data, timestamp } = await retreiveCachedResponse("getNearbyStores");
    if (Date.now() - timestamp < 1000 * 60 * 5) {
      return data;
    }

    let response = await (await fetch(`${baseUrl}/stores/${postCode}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).json();

    cacheResponse("getNearbyStores", {
      data: response.data.data,
      timestamp: Date.now()
    });
    return response.data.data;
  } catch (error) {
    console.error(error);
    return (await retreiveCachedResponse("getNearbyStores")).data;
  }
}

export async function createStoreComment({
    store_id,
    priority,
    inspection_note,
    machines,
    tools,
    require_action,
    sheet_required,
    spare_hire_book,
    new_book_required,
    hire_docket_collected,
    docket_num_01,
    docket_num_02,
    docket_comment,
    request_docket,
    request_docket_comment,
    request_docket_comment2,
    stand_condition,
    stand_note,
    alert,
  }) {
  let { id } = await getUser();
  let token = await getToken();
  let response = {};
  const title = `${inspection_note} - ${new Date().toString()}`;
  const label = "STORE COMMENT FORM";

  // Adding in required props if they dont exist
  machines = machines.map(({ machine_id, machine_status, faulty_reason }) => ({
    require_swap: false,
    machine_id,
    id: machine_id,
    machine_status,
    faulty_reason
  }));

  tools = tools.map(({ tool_id, tool_status, faulty_reason }) => ({
    require_swap: false,
    tool_id,
    id: tool_id,
    tool_status,
    faulty_reason
  }));

  const url = `${baseUrl}/inspection/store`;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: id,
      priority,
      require_action,
      inspection_note,
      store_id,
      machines: machines,
      tools: tools,
      sheet_required,
      spare_hire_book,
      new_book_required,
      hire_docket_collected,
      docket_num_01,
      docket_num_02,
      docket_comment,
      request_docket,
      request_docket_comment,
      request_docket_comment2,
      stand_condition,
      stand_note,
      alert,
    })
  };

  try {
    response = await fetch(url, options);
  } catch (error) {
    cacheResponse("savedForms", { url, options, label, title }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}

export async function updateStoreComment({
    group_id,
    complete,
    added_note,
    store_id
  }) {
  let token = await getToken();
  let response = {};

  const title = `${added_note} - ${new Date().toString()}`;
  const label = "UPDATE STORE COMMENT";
  const url = `${baseUrl}/store/inspections/${group_id}/update`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ complete, added_note, store_id })
  };

  try {
    response = await fetch(url, options);
  } catch (error) {
    cacheResponse("savedForms", { url, options, label, title }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}

export async function notiAction(id){
  let token = await getToken();
  const url = `${baseUrl}/notis/update/${id}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ id })
  };
  try {
    let response = await fetch(url, options);
    return response.status;
  } catch (error) {
    cacheResponse("notiAction", { id }, true);
    notify("Failed to update notificaion.", "error");
  }
  
}


// WEBPACK FOOTER //
// ./src/backend/stores.js